import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { ImportSystemObject } from './import-system-object.model';
import { ImportSystemObjectType, ImportSystemObjectTypes } from './import-system-object-type';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { FileUploadModel } from '@fi-app/utilities/file-upload/file-upload.model';
import { ImportSystemObjectService } from './import-system-object.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { BehaviorSubject } from 'rxjs';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AppTextService } from '@fi-shared/app-text';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-system-objects-import',
    templateUrl: './system-objects-import.component.html',
    styleUrls: ['./system-objects-import.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-system-objects-import' },
    standalone: false,
})
export class SystemObjectsImportComponent implements OnInit {
    EditTabs: EditTabsModel;
    Files$ = new BehaviorSubject<File[]>([]);
    ImportSystemObject: ImportSystemObject;
    contentLanguageListData = new DropdownSettingsModelV2<IContentLanguage>({
        filterBy: 'Name',
    });
    ImportSystemObjectTypes: { Id: ImportSystemObjectType; TextId: string }[];
    FileUploadModel: FileUploadModel;
    private readonly fileUploadAcceptType = '.xlsx';

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private importSystemObjectService: ImportSystemObjectService,
        private fiLoadingService: LoadingService,
        private stateService: FiStateService,
        private saveChangesWarningService: SaveChangesWarningService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.setSystemObjectsImportData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.appTextService.get('system_objects.import'));
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    private setSystemObjectsImportData() {
        this.contentLanguageListData.setDataSet(this.contentLanguagesService.GetContentLanguages());

        this.ImportSystemObject = new ImportSystemObject();
        this.ImportSystemObjectTypes = ImportSystemObjectTypes;

        this.FileUploadModel = new FileUploadModel(this.onFileSelect.bind(this));
        this.FileUploadModel.accept = this.fileUploadAcceptType;

        const getModelData = () => ({
            import: this.ImportSystemObject,
        });

        this.saveChangesWarningService.start(getModelData);
    }

    save() {
        this.fiLoadingService
            .trackPromise(
                this.importSystemObjectService.ProcessImportSystemObject(this.Files$.value, this.ImportSystemObject),
            )
            .then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(
                    this.ImportSystemObject.ImportSystemObjectType === ImportSystemObjectType.User
                        ? FiStateNames.User.List
                        : FiStateNames.BusinessUnit.List,
                );
            });
    }

    private onFileSelect($files: File[]) {
        const files: File[] = this.Files$.value;
        if (!!$files.length) {
            Array.from($files, (file: File) => {
                files.push(file);
            });
        }
        this.Files$.next(files);
    }
}
